<template>
    <footer class="footer bg-dark text-white fixed-bottom rounded-top shadow">
      <div class="container-fluid py-3">
        <div class="row">
          <div class="col-md-6 text-center text-md-start">
            <span class="#text-muted text-white">&copy; 2025 Asdecode. Tous droits réservés.</span>
          </div>
          <!-- <div class="col-md-6 text-center text-md-end">
            <a href="#" class="text-white me-3"><i class="fas fa-question-circle"></i> Aide</a>
            <a href="#" class="text-white me-3"><i class="fas fa-envelope"></i> Contact</a>
            <a href="#" class="text-white"><i class="fas fa-shield-alt"></i> Confidentialité</a>
          </div> -->
        </div>
      </div>
    </footer>
  </template>
  
  <script>
  export default {
    name: 'ClientFooter'
  }
  </script>
  
  <style scoped>
  .footer {
    padding: 0.5rem 0;
  }
  
  .footer a {
    text-decoration: none;
    transition: color 0.3s;
  }
  
  .footer a:hover {
    color: var(--bs-primary) !important;
  }
  </style>